import { render, staticRenderFns } from "./activeXP.vue?vue&type=template&id=c96c47da&scoped=true&"
import script from "./activeXP.vue?vue&type=script&lang=js&"
export * from "./activeXP.vue?vue&type=script&lang=js&"
import style0 from "./activeXP.vue?vue&type=style&index=0&id=c96c47da&scoped=true&lang=less&"
import style1 from "./activeXP.vue?vue&type=style&index=1&id=c96c47da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96c47da",
  null
  
)

export default component.exports